import type { ActionItemType, ActionItemsResponse } from '@trulyinbox/types';
import { apiFetch } from './api';

export type {
  ActionItem,
  ActionItemDetail,
  ActionItemDnsRecord,
  ActionItemType,
  ActionItemsResponse,
  LimitAlert,
  LimitAlertType,
} from '@trulyinbox/types';

export type ListActionItemsParams = {
  type?: ActionItemType;
  page?: number;
  pageSize?: number;
};

/**
 * `GET /email-accounts/action-items` — the mailboxes that need the user to act
 * (DNS not configured, not sending, receiving isolated, suspended with no
 * auto-resume).
 * Workspace-scoped server-side via the JWT; the response is a derived view, so
 * a fix reflected elsewhere simply makes the row disappear on the next fetch.
 */
export async function listActionItems(
  params: ListActionItemsParams = {},
): Promise<ActionItemsResponse> {
  const search = new URLSearchParams();
  if (params.type) search.set('type', params.type);
  if (params.page != null) search.set('page', String(params.page));
  if (params.pageSize != null) search.set('pageSize', String(params.pageSize));
  const qs = search.toString();
  return apiFetch<ActionItemsResponse>(`/email-accounts/action-items${qs ? `?${qs}` : ''}`);
}
